module.exports = __webpack_public_path__ + "img/female.db702aab.svg";